import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "../../services/firebase.service";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";

function useAuthUser() {
  const [user, setUser] = useState<null | User | undefined>(
    auth?.currentUser ?? null,
  );
  const [isLoggedIn, { open: loggedIn, close: notLoggedIn }] =
    useDisclosure(false);

  onAuthStateChanged(auth, (user) => {
    if (user) {
      setUser(user);
      loggedIn();
    } else {
      setUser(null);
      notLoggedIn();
    }
  });

  return { user, isLoggedIn };
}

export default useAuthUser;
